interface IsValidScriptArgs {
  resource: PerformanceResourceTiming
  origin: string
  maxStartTime: number
  onlySameOrigin: boolean
  pathPrefixes: string[]
}

export const isValidScript = ({ resource, origin, maxStartTime, onlySameOrigin, pathPrefixes }: IsValidScriptArgs) => {
  const { initiatorType, startTime, name } = resource

  const isScript = initiatorType === 'script'
  const isLate = startTime > maxStartTime
  const isJsFile = /\.js(\?|$)/i.test(resource.name)

  if (!isScript || isLate || !isJsFile) {
    return false
  }

  try {
    const url = new URL(name, window.location.href)
    const isSameOrigin = !onlySameOrigin || url.origin === origin
    const isPathMatch =
      pathPrefixes.length === 0 || pathPrefixes.some((pathPrefix) => url.pathname.startsWith(pathPrefix))

    return isSameOrigin && isPathMatch
  } catch {
    return false
  }
}
